import {mapGenerator} from '../config/axios'

export const fetchHeatmaps = (map, hours, callback) => {
    return mapGenerator.get('/maps/' + map + '/' + hours)
        .then((response) => callback(response.data))
        .catch((err) => console.log(err))
}

export const generateHeatmap = (callback) => {
    const timestamp = new Date().getTime()
    return mapGenerator.post('/maps', {
        timestamp: timestamp
    })
        .then(response => callback(response.data))
        .catch(err => console.log(err))
}

export const deleteAllHeatmaps = (callback) => {
    return mapGenerator.delete('/maps')
        .then(() => callback())
        .catch((err) => {
            console.error(err)
            callback()
        })
}



// WEBPACK FOOTER //
// ./src/requests/heatmaps.js